import {
  Button,
  Card,
  CircularProgress,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { loginLocal } from "../api/api";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import Box from "@mui/material/Box";
import { useMedia } from "react-use";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "store/store";
import GoogleIcon from "@mui/icons-material/Google";
import CheckIcon from "@mui/icons-material/Check";

const SignIn = () => {
  const [loginError, setLoginError] = useState<any>();
  const queryClient = useQueryClient();
  const isDarkTheme = useMedia("(prefers-color-scheme: dark)");
  const { setToken } = useAuthState();
  const { mutateAsync, isLoading } = useMutation("loginLocal", loginLocal, {
    onSettled: (data) => {
      queryClient.invalidateQueries("profile");
    },
    onSuccess: (data) => {
      setToken(data.data.accessToken);
    },
  });
  const navigate = useNavigate();
  const isWide = useMedia("(min-width: 600px)");

  const HeaderContent2 = () => {
    return (
      <Box sx={{ maxWidth: "500px", margin: "0 auto" }}>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            margin: { xs: "6px 0 12px", md: "12px 0 24px" },
            fontSize: { xs: "1.1rem", md: "1.4rem" },
            fontWeight: 700,
          }}
        >
          With Spidipay you can
        </Typography>
        <List
          dense={true}
          sx={{
            mt: 0,
          }}
        >
          <ListItem dense>
            <ListItemIcon sx={{ margin: 0 }}>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText>
              Focus critical developer resources on your core business
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon sx={{ margin: 0 }}>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText>
              Launch new products faster with minimal payments code
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon sx={{ margin: 0 }}>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText>
              Provide the smoothest payment experience to your customers
            </ListItemText>
          </ListItem>
        </List>
      </Box>
    );
  };

  const HeaderContent = () => {
    return (
      <Box sx={{ maxWidth: "640px", margin: "0 auto" }}>
        <List
          dense={true}
          sx={{
            mt: 0,
          }}
        >
          <ListItem dense>
            <ListItemIcon sx={{ margin: 0 }}>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ fontWeight: 700 }}>
                Get started quickly
              </Typography>
              Integrate with developer-friendly APIs or choose low-code or
              pre-built solutions.
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon sx={{ margin: 0 }}>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ fontWeight: 700 }}>
                Support any business model
              </Typography>
              E-commerce, physical store, marketplaces, and more — all within a
              unified platform.
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemIcon sx={{ margin: 0 }}>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ fontWeight: 700 }}>
                Join the cutting edge
              </Typography>
              Be an ambitious startup or an enterprise of any size.
            </ListItemText>
          </ListItem>
        </List>
      </Box>
    );
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      {/* 
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        onSubmit={async ({ email, password }, { setSubmitting }) => {
          try {
            await mutateAsync({ email, password });
          } catch (error: any) {
            setLoginError(error);
          }

          setSubmitting(false);
        }}
      >
        {({ submitForm, isSubmitting }) => (
          <Form style={{ width: "100%" }}>
            <Card
              sx={{
                width: "100%",
                maxWidth: "450px",
                borderWidth: isDarkTheme ? "0px" : "1px",
                padding: { xs: "16px 16px 22px", sm: "32px 40px 32px" },
                margin: { xs: "16px auto 0", sm: "60px auto 0" },
                display: "flex",
                flexDirection: "column",
                gap: 3,
                position: "relative",
                textAlign: "center",
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  textAlign: "left",
                  mt: 1,
                  mb: 2,
                  fontSize: "1.5rem",
                }}
              >
                Sign in to your account
              </Typography>
              <Field
                size="small"
                component={TextField}
                label="Email"
                name="email"
                sx={{ width: "100%" }}
              />
              <Field
                size="small"
                component={TextField}
                type="password"
                label="Password"
                name="password"
                sx={{ width: "100%" }}
              />
              {loginError && (
                <Box sx={{ color: "#d93025" }}>
                  {!!loginError.message ? loginError.message : loginError}
                </Box>
              )}
              <Box
                sx={{
                  textAlign: "right",
                  mt: 2,
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Box sx={{ flex: "1 1 auto" }} />
                <Box
                  sx={{
                    textAlign: "right",
                    margin: { xs: "0 0 16px", sm: "16px 0" },
                  }}
                >
                  <Button
                    color="primary"
                    size="large"
                    variant="contained"
                    disabled={isSubmitting}
                    onClick={submitForm}
                    sx={{ padding: "6px 24px", width: "114px", height: "38px" }}
                  >
                    {!isLoading ? (
                      "Continue"
                    ) : (
                      <CircularProgress size={"19px"} />
                    )}
                  </Button>
                </Box>
              </Box>
            </Card>
          </Form>
        )}
      </Formik>
      <Typography sx={{ mt: 2 }}>
        Don&apos;t have an account?{" "}
        <Link
          underline="hover"
          onClick={() => {
            navigate("/signup");
          }}
          sx={{ cursor: "pointer" }}
        >
          Sign up
        </Link>
      </Typography>
       */}
      {/* <HeaderContent /> */}
      <HeaderContent2 />
      <Box sx={{ mt: 2 }}>
        <Button
          href={`${import.meta.env.VITE_API_URL}/auth/google`}
          variant="contained"
          startIcon={<GoogleIcon />}
        >
          Sign in with Google
        </Button>
      </Box>
    </Box>
  );
};

export default SignIn;
